import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

interface MotivatorCardProps {
  id: string;
  name: string;
  description: string;
  image: string;
}

export const MotivatorCard = ({ id, name, description, image }: MotivatorCardProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    touchAction: 'none',
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className="relative w-full cursor-grab active:cursor-grabbing"
    >
      {/* Card Container */}
      <div className="relative aspect-[2/3] w-full max-w-[120px] mx-auto overflow-hidden rounded-lg shadow-lg transition-transform hover:scale-105">
        {/* Card Image */}
        <img
          src={image}
          alt={name}
          className="h-full w-full object-cover"
          draggable={false}
        />

        {/* Floating Name (Top) */}
        <div className="absolute left-0 right-0 top-0 p-1.5">
          <div className="rounded-md bg-black/40 px-1.5 py-0.5 text-center backdrop-blur-sm">
            <h3 className="text-xs font-bold text-white drop-shadow-md">{name}</h3>
          </div>
        </div>

        {/* Floating Description (Bottom) */}
        <div className="absolute bottom-0 left-0 right-0 p-1.5">
          <div className="rounded-md bg-black/40 px-1.5 py-0.5 backdrop-blur-sm">
            <p className="text-center text-[10px] leading-tight text-white drop-shadow-md">{description}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
